import React from 'react';
import { injectIntl } from 'react-intl';
import { colorToArray, i18nIntl } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

/*
	// must be sorted by completed_date ASC
	current:[
		{ key:'step_key', date:completed_date },
		{ ... },
	}]

	all_steps:[
		{ key:'step_key', title:"Title", color:'rgba(RRR, GGG, BBB, AA)', ... },
		{ ... },
	}]
 */

const HistoricLogsMap = ({ all_steps, current, ...props }) => {
	useCSS('comp/steps.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const display_only_completed = props?.display_only_completed ?? true;

	const start_steps = props?.start_steps ?? [];
	const end_steps = props?.end_steps ?? [];
	const date_format = props?.date_format ?? 'ddd L, LT';
	const is_backend = props?.is_backend ?? true;

	const classes = ['gui_progress_steps'];

	if(is_backend === false) {
		classes.push('simple_layout');

		const step = all_steps.find((s) => (s.key == current[current.length - 1].key));

		const has_completed = current.find((c) => (c.key == step.key));
		if(display_only_completed && (!has_completed || has_completed == undefined)) return null;

		if(has_completed.date == '0000-00-00 00:00:00') return null;

		let step_styles = { };
		if(step.color != undefined) {
			let color_to_array = colorToArray(step.color);
			step_styles['--highlight-color'] = (color_to_array !== false) ? color_to_array.join(", ") : `var(--ep-${step.color}-color)`;
		}

		return (
			<div class={classes.join(" ")}>
				<div class="contents">
					<strong class="title"><span>{i18n("Status")}:</span> {i18n(step?.front_title ?? step.title)}</strong>

					<span class="date">
						{EPDateFormat(has_completed.date, date_format)}
					</span>
				</div>
			</div>
		)
	}

	classes.push('is_backend');

	return (
		<ul class={classes.join(" ")}>
			{all_steps.map((step) => {
				const has_completed = current.find((c) => ( c.key == step.key ));
				if(display_only_completed && (!has_completed || has_completed == undefined)) return null;

				if(has_completed.date == '0000-00-00 00:00:00') return null;

				let step_styles = { };
				if(step.color != undefined) {
					let color_to_array = colorToArray(step.color);
					step_styles['--highlight-color'] = (color_to_array !== false) ? color_to_array.join(", ") : `var(--ep-${step.color}-color)`;
				}

				const is_start = (start_steps.includes(step.key)) ? true : false;
				const is_end = (end_steps.includes(step.key)) ? true : false;

				let step_classes = ['step'];
				if(is_start) step_classes.push('is_start');
				if(is_end) step_classes.push('is_end');

				return (
					<li key={`step_${step.key}`} class={step_classes.join(" ")} style={step_styles}>
						<span class="dot" />
						
						<div class="contents">
							<strong class="title">{i18n(step.title)}</strong>

							<span class="date">
								{EPDateFormat(has_completed.date, date_format)}

								{(has_completed.agent_name != undefined) && (
									<span
										class="agent gui_not_in_start_small"
										dangerouslySetInnerHTML={{
											__html:props.intl.formatMessage({
												id:"(by {name})",
											}, {
												name:`<strong>${has_completed.agent_name}</strong>`,
											}),
										}}
									/>
								)}
							</span>
						</div>
					</li>
				)
			})}
		</ul>
	)
};

export default injectIntl(HistoricLogsMap);